// Web helpers for managing the browser URL.
import { getIsInIFrame } from 'util/util';

export function historyGetState() {
    return history.state;
}

export function historyHasHistory() {
    if (getIsInIFrame(window)) {
        // For iframes, check if we have more than the initial URL in our custom stack
        return iframeHistoryStack.length > 1;
    } else {
        return history.state !== null;
    }
}

export function watchPopState(callback) {
    window.addEventListener('popstate', (event) => callback(event.state));
}

export function getIsLocalhost() {
    const commonLocalHosts = `localhost|192\\.168\\.\\d{1,3}\\.\\d{1,3}|${process.env.REACT_APP_PSI_LOCAL_IP}`;
    return new RegExp(commonLocalHosts).test(location.hostname);
}

export function getSiloKeyFromWindowUrl() {
    return window.location.pathname.split('/')[1];
}

export function getLanguageFromWindowUrl() {
    if (getFragment().includes('state=rc')) {
        return 'french_canadian';
    }
    return null;
}

export function getThemeFromWindowUrl() {
    return new URLSearchParams(window.location.search).get('theme_g');
}

export function setTitle(title) {
    window.document.title = title;
}

export function getIsInSidebar() {
    return getIsInIFrame(window);
}

// This value is injected by supported native apps to indicate that the web app is running in a webview. See docs/native-webview.md for more information.
export function getIsInPsiNativeAppWebview() {
    return (window as any).isInPsiNativeAppWebview;
}

export function getFragment() {
    return window.location.hash;
}

// Iframe navigation stack management
const iframeHistoryStack: string[] = [];

// Initialize the history stack with the current URL for iframes
if (getIsInIFrame(window)) {
    iframeHistoryStack.push(window.location.href);
}

export function historyBack() {
    if (getIsInIFrame(window)) {
        // For iframes, maintain our own navigation stack
        // to avoid affecting the parent window's back button
        if (iframeHistoryStack.length > 1) {
            iframeHistoryStack.pop();
            const previousUrl = iframeHistoryStack[iframeHistoryStack.length - 1];
            window.history.replaceState(null, '', previousUrl);
            window.dispatchEvent(new PopStateEvent('popstate', { state: { url: previousUrl } }));
        }
    } else {
        // When not in iframe, use normal history.back()
        history.back();
    }
}

export function historyPushState({ state, url }) {
    if (getIsInIFrame(window)) {
        iframeHistoryStack.push(url);
        // Use replaceState to actually change the URL in iframe
        // to avoid affecting the parent window's back button
        history.replaceState(state, '', url);
    } else {
        history.pushState(state, '', url);
    }
}

export function historyReplaceState({ state, url }) {
    if (getIsInIFrame(window) && iframeHistoryStack.length > 0) {
        iframeHistoryStack[iframeHistoryStack.length - 1] = url;
    }
    history.replaceState(state, '', url);
}
